import { render, staticRenderFns } from "./ProductTechSpecs.vue?vue&type=template&id=b5a4ea46&scoped=true&lang=pug&"
import script from "./ProductTechSpecs.vue?vue&type=script&lang=js&"
export * from "./ProductTechSpecs.vue?vue&type=script&lang=js&"
import style0 from "./ProductTechSpecs.vue?vue&type=style&index=0&id=b5a4ea46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a4ea46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a4ea46')) {
      api.createRecord('b5a4ea46', component.options)
    } else {
      api.reload('b5a4ea46', component.options)
    }
    module.hot.accept("./ProductTechSpecs.vue?vue&type=template&id=b5a4ea46&scoped=true&lang=pug&", function () {
      api.rerender('b5a4ea46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductTechSpecs.vue"
export default component.exports